module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SR - Suriname.c8a1f450.svg";